import { render, staticRenderFns } from "./orderDatails.vue?vue&type=template&id=51c9d20a&scoped=true"
import script from "./orderDatails.vue?vue&type=script&lang=js"
export * from "./orderDatails.vue?vue&type=script&lang=js"
import style0 from "./orderDatails.vue?vue&type=style&index=0&id=51c9d20a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c9d20a",
  null
  
)

export default component.exports